// [ai] journal: the streak, today's instruments (done or not, each a link to its runner) and the latest entries.
import { ErrorCard } from "../cards";
import { querySpec, useHostQuery, Wait, type WidgetProps } from "./hooks";
import { Rows } from "./Rows";
import type { Schema } from "../props";
export const JOURNAL_PROPS: Schema = { n: { type: "number" } };
type Journal = { entries: { href: string; date: string; instrument: string; emoji?: string; title: string }[]; streak: number; today: { name: string; title: string; emoji?: string; done: boolean }[] };
export function Journal({ spec }: WidgetProps) {
  const n = (spec.props?.n as number | undefined) ?? 7; const q = useHostQuery<Journal>(querySpec(spec, "journal", { n }));
  if (q.error) return <ErrorCard text={q.error.message} />; if (q.data === undefined) return <Wait />;
  const d = q.data;
  return (
    <div className="at-cat at-cat-journal">
      <div className="at-cat-head"><span className="at-cat-streak">🔥 {d.streak} day{d.streak === 1 ? "" : "s"}</span>
        {d.today.length ? <Rows rows={d.today.map(t => ({ key: t.name, href: `/do/${t.name}`, title: t.title, emoji: t.emoji, sub: t.done ? "done ✓" : "waiting" }))} /> : null}</div>
      <Rows rows={d.entries.slice(0, n).map(e => ({ key: e.href, href: e.href, title: e.title, emoji: e.emoji }))} empty="No entries yet — today's is one click away." />
    </div>
  );
}
